<template>
    <div class="radio-group" :class="{ 'radio-group--column-mobile': columnMobile }">
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
    import { defineProps, defineEmits, provide, ref, watch } from 'vue';

    const props = defineProps({
        modelValue: {
            type: [String, Number, Boolean],
            required: false,
        },
        columnMobile: {
            type: Boolean,
            default: false,
        },
    });

    const emit = defineEmits<{
        (e: 'update:modelValue', value: string | number | boolean | undefined): void,
    }>();

    const currentValue = ref(props.modelValue);

    watch(
        () => props.modelValue,
        (newValue) => {
            currentValue.value = newValue;
        },
    );

    watch(currentValue, (newValue) => {
        emit('update:modelValue', newValue);
    });

    provide('radioGroup', {
        modelValue: currentValue,
        updateModelValue: (value: string | number) => {
            if (currentValue.value !== value) {
                currentValue.value = value;
            }
        },
    });
</script>

<style lang="scss" scoped>
    @use "./UIRadioGroup.scss" as *;
</style>
